import React from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
} from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import assinatura from "../img/assinatura.jpg";
import timbre from "../img/timbre.jpg";

function Table({ data, onDelete, onClearAll }) {
  const gerarPDF = (item) => {
    const doc = new jsPDF("p", "mm", "a4");
    const dataAtual = new Date().toLocaleDateString("pt-BR");
    const idade = calcularIdade(item.dataNascimento);

    // Adicionar timbre no topo
    const timbreImg = new Image();
    timbreImg.src = timbre;
    doc.addImage(timbreImg, "JPEG", 10, 10, 190, 40);

    // Linhas horizontais de separação
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(10, 55, 200, 55); // Linha superior ajustada
    doc.line(10, 75, 200, 75); // Linha abaixo do cabeçalho

    // Título e informações gerais
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`Paciente: ${item.nome}`, 10, 60);
    doc.text(`Registro: ${item.numeroRegistro}`, 150, 60);
    doc.text(`Idade: ${idade}`, 10, 65);
    doc.text(`Sexo: ${item.sexo}`, 60, 65); // Exibição do sexo
    doc.text(`Local: ${item.local}`, 150, 65); // Exibição do local
    doc.text(`Convênio: PREFEITURA DE LIMOEIRO`, 10, 70);
    doc.text(`Emissão: ${dataAtual}`, 150, 70);

    // Resultado Parasitológico
    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text("RESULTADO PARASITOLÓGICO", 10, 85);

    doc.setFontSize(12);
    doc.setFont("Helvetica", "normal");
    doc.text("REQUISITANTE: UBS", 10, 95);
    doc.text(`Número da Família: ${item.numeroFamilia}`, 10, 100);
    doc.text(`D.N.: ${formatarData(item.dataNascimento)}`, 150, 100);
    doc.text("TIPO DE AMOSTRA: ÚNICA", 10, 105);
    doc.text("MÉTODO: Teste qualitativo-quantitativo Kato-Katz", 10, 110);

    doc.line(10, 115, 200, 115); // Linha abaixo da seção

    doc.setFontSize(14);
    doc.setFont("Helvetica", "bold");
    doc.text(`RESULTADO: ${item.resultado}`, 10, 125);

    doc.line(10, 130, 200, 130); // Linha abaixo do resultado

    // Metodologia
    doc.setFontSize(12);
    doc.setFont("Helvetica", "normal");
    const metodologiaTexto =
      "A metodologia se adequa a pesquisa de S. mansoni e outros helmintos, entretanto não é possível a detecção de protozoários.";
    const metodologiaLinhas = doc.splitTextToSize(metodologiaTexto, 180);
    doc.text(metodologiaLinhas, 10, 140);

    // Rodapé com assinatura no lado direito
    const assinaturaImg = new Image();
    assinaturaImg.src = assinatura;
    doc.addImage(assinaturaImg, "JPEG", 130, 210, 75, 55);

    // Estilo do Aviso (Rodapé)
    const avisoTexto =
      "Os resultados dos exames de laboratório sofrem influência de estado fisiológico, patológico e uso de medicação. Somente seu médico tem condições de analisar corretamente este resultado.";

    doc.setFontSize(10);
    doc.setFont("Courier", "italic");
    doc.setFillColor(230, 230, 230); // Cor de fundo cinza claro
    const avisoLinhas = doc.splitTextToSize(avisoTexto, 180);
    doc.text(avisoLinhas, 15, 266);

    // Salvar o PDF com o nome formatado
    doc.save(`Resultado-${item.nome}_${item.numeroRegistro}.pdf`);
  };

  // Função para formatar a data no formato DD/MM/YYYY
  const formatarData = (data) => {
    const dateObj = new Date(data);
    if (isNaN(dateObj)) return ""; // Retorna vazio se a data for inválida
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const mes = String(dateObj.getMonth() + 1).padStart(2, "0");
    const ano = dateObj.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  // Função para calcular a idade
  const calcularIdade = (dataNascimento) => {
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);

    let anos = hoje.getFullYear() - nascimento.getFullYear();
    let meses = hoje.getMonth() - nascimento.getMonth();

    if (meses < 0 || (meses === 0 && hoje.getDate() < nascimento.getDate())) {
      anos--;
      meses += 12;
    }

    if (hoje.getDate() < nascimento.getDate()) {
      meses--;
      if (meses < 0) {
        anos--;
        meses += 12;
      }
    }

    return `${anos}A ${meses}M`;
  };

  return (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={onClearAll}
        sx={{ mb: 2 }}
      >
        Limpar Todos os Registros
      </Button>
      <TableContainer component={Paper}>
        <MuiTable>
          <TableHead>
            <TableRow>
              <TableCell>Número de Registro</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Resultado</TableCell>
              <TableCell>Data de Nascimento</TableCell>
              <TableCell>Idade</TableCell>
              <TableCell>Sexo</TableCell>
              <TableCell>Número da Família</TableCell>
              <TableCell>Local</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...data].reverse().map((item, index) => ( // Inverte a ordem dos dados
              <TableRow key={index}>
                <TableCell>{item.numeroRegistro}</TableCell>
                <TableCell>{item.nome}</TableCell>
                <TableCell>{item.resultado}</TableCell>
                <TableCell>{formatarData(item.dataNascimento)}</TableCell>
                <TableCell>{calcularIdade(item.dataNascimento)}</TableCell>
                <TableCell>{item.sexo}</TableCell>
                <TableCell>{item.numeroFamilia}</TableCell>
                <TableCell>{item.local}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => gerarPDF(item)}
                  >
                    Gerar PDF
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => onDelete(item.numeroRegistro)}
                    sx={{ ml: 1 }}
                  >
                    Excluir
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </>
  );
}

export default Table;
